import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface IProps {
	id: string;
	onTrashCanClick: (input: string) => void;
}

const InputTrashButton = (props: IProps) => {
	return (
		<span
			className="input-group-text input-label-field-button"
			onClick={() => props.onTrashCanClick(props.id)}
		>
			<FontAwesomeIcon icon={faTrash} style={{ color: '#999' }} />
		</span>
	);
};

export default InputTrashButton;
